// https://app.growthbook.io/features/pen-7387_v1
export const EXPERIMENT_FLAG = 'pen-7387_v1'
